import { Roles } from '../form-portaluser-type';
import DisplayAccessArea from './display-non-admin-area';
import DisplayAdminArea from './display-admin-area';
import DisplayPersArea from './display-pers-area';

/**
 * Function that displays the access area depending on WordPress role.
 * 
 * @param {Roles} role the WordPress role
 */
export const displayUserAccessArea = (role: Roles) => {
  switch (role) {
    case 'card_group_reporting':
      return DisplayAccessArea('Card Group');
    case 'customer_reporting':
    case 'customer_admin':
      return DisplayAccessArea('Customer');
    case 'partner_reporting':
    case 'partner_admin':
      return DisplayAccessArea('Partner');
    case 'site_reporting':
    case 'site_admin':
      return DisplayAccessArea('Terminal');
    case 'aag_reporting':
    case 'aag_admin':
      return DisplayAdminArea();
    case 'pers':
      return DisplayPersArea();
  }
}